module.exports = __webpack_public_path__ + "static/media/ic_more.f53a01b0.svg";